<glxy-form-field class="account-selector-field" appearance="outline">
  <glxy-label>{{ 'FRONTEND.SALES_UI.ACCOUNT' | translate }}</glxy-label>
  <input type="text" matInput aria-label="Account" [formControl]="accountControl" [matAutocomplete]="auto" />
  <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption [displayWith]="displayCompanyName">
    <mat-option *ngIf="allowNoneOption">
      {{ 'FRONTEND.SALES_UI.COMMON.NONE_LABEL' | translate }}
    </mat-option>
    <mat-option *ngFor="let account of filteredAccounts$ | async" [value]="account">
      {{ account.companyName }}
    </mat-option>
  </mat-autocomplete>
</glxy-form-field>
